module.exports = "<h2 class=\"not-found__label\"><span>404</span> Page is not found</h2>"


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/not-found/not-found.component.html
// module id = ../../../../../angular/app/components/defaults/not-found/not-found.component.html
// module chunks = 1